import { Directive, ElementRef, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { CnpjUtils } from '../../shared/utils/cnpj-utils';

@Directive({
  selector:
    // tslint:disable-next-line:max-line-length
    '[appCpfCnpjValidator][formControlName],[appCpfCnpjValidator][formControl],[appCpfCnpjValidator][ngModel],',
  providers: [
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfCnpjValidatorDirective),
    },
  ],
})
export class CpfCnpjValidatorDirective implements Validator {
  constructor(private element: ElementRef) {}

  validate(control: AbstractControl): { [key: string]: any } {
    const cpfCheck = control?.value ?? this.element.nativeElement.value ?? '';
    return this.validar(cpfCheck);
  }

  validar(valor) {
    if (!valor) return null;

    if (CnpjUtils.isCnpj(valor)) {
      if (!this.validarCnpj(valor)) {
        return { cnpjCheck: true, message: 'CNPJ inválido' };
      }
    } else {
      if (!this.validarCpf(valor)) {
        return { cpfCheck: true, message: 'CPF inválido' };
      }
    }
    return null;
  }

  validarCpf(valor) {
    const vl = valor.replace(/[^0-9]/g, '');
    const digitos = vl.substr(0, 9);
    let novoCpf = this.calcDigitosPosicoes(digitos);
    novoCpf = this.calcDigitosPosicoes(novoCpf, 11);
    return novoCpf === vl;
  }

  validarCnpj(valor) {
    return CnpjUtils.isValidWithCheckDigits(valor);
  }

  private calcDigitosPosicoes(digitos: string, posicoes = 10, somaDigitos = 0): string {
    let auxPos = posicoes;
    let auxSum = somaDigitos;

    for (const ch of digitos) {
      auxSum += this.charToValue(ch) * auxPos;
      auxPos--;
      if (auxPos < 2) {
        auxPos = 9;
      }
    }

    auxSum = auxSum % 11;
    auxSum = auxSum < 2 ? 0 : 11 - auxSum;

    return digitos + auxSum;
  }

  private charToValue(char: string): number {
    return char.charCodeAt(0) - 48;
  }
}
